import { render } from "./VPC.vue?vue&type=template&id=78f03f92&scoped=true"
import script from "./VPC.vue?vue&type=script&lang=js"
export * from "./VPC.vue?vue&type=script&lang=js"

import "./VPC.vue?vue&type=style&index=0&id=78f03f92&scoped=true&lang=scss"

import exportComponent from "/home/biktorgj/Projects/Linube Cloud/Server_and_UI/ui-prod-4.22/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78f03f92"]])

export default __exports__